import script from "./MainNavBar.vue?vue&type=script&setup=true&lang=js"
export * from "./MainNavBar.vue?vue&type=script&setup=true&lang=js"

import "./MainNavBar.vue?vue&type=style&index=0&id=027f795b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-027f795b"]])

export default __exports__